import DOMPurify from "dompurify";

const SANITIZE_OPTIONS = {
  FORBID_TAGS: ["script", "style"],
  FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
};

export const sanitizeSnapshotEventHtml = (html: string): string => DOMPurify.sanitize(html, SANITIZE_OPTIONS);
